export default "__VITE_ASSET__b462b510__"